<template>
  <div>
    <div v-if="title">
      <b-field :label="$t('legalCountry')">
        <b-autocomplete
          v-model="countryInput"
          :data="avCountriesFiltered"
          icon="earth"
          field="name"
          :open-on-focus="true"
          :placeholder="$t('selectACountry')"
          :loading="isLoading"
          autocomplete="off"
          @select="(option) => setCountry(option)"
        />
      </b-field>
    </div>
    <div v-else>
      <b-autocomplete
        v-model="countryInput"
        :data="avCountriesFiltered"
        icon="earth"
        field="name"
        :open-on-focus="true"
        :placeholder="$t('selectACountry')"
        :loading="isLoading"
        autocomplete="off"
        @select="(option) => setCountry(option)"
      />
    </div>
  </div>
</template>

<script>
import isoCountries from "@/iso-countries";

export default {
  name: "CountryPicker",
  props: {
    value: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      countryInput: "",
    };
  },
  computed: {
    avCountries() {
      return isoCountries;
    },
    avCountriesFiltered() {
      return this.avCountries.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(this.countryInput.toLowerCase()) >= 0 ||
          (option.alpha3 && option.alpha3.toString().toLowerCase().indexOf(this.countryInput.toLowerCase()) >= 0)
        );
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(legalCountry) {
        if (this.countryInput == "" && legalCountry != "") {
          if (legalCountry == "de") {
            this.countryInput = "Deutschland";
            return;
          }
          let country = isoCountries.filter((y) => y.alpha2 === legalCountry);
          if (country) {
            this.countryInput = country[0].name;
          }
        }
      },
    },
    countryInput: {
      deep: true,
      handler(newVal) {
        if (this.avCountries.find((option) => option.name == newVal)) {
          this.$emit("input", this.avCountries.find((option) => option.name == newVal).alpha2);
        }
        this.$emit("checkValidity");
      },
    },
  },
  methods: {
    setCountry(option) {
      this.$emit("input", "");
      if (option) {
        this.$emit("input", option.alpha2);
      }
      this.$emit("checkValidity");
    },
  },
};
</script>

<style></style>
